import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import Constants from "../../../../common/CustomerConstants";
import { SearchField } from "../../../../Components/formElements/SearchField";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import { getPurchaseList, purchaseNr } from "../../../../redux/feature/customer_app/customerSlice";
import CustomerConstants from "../../../../common/CustomerConstants";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
// import UploadPurchaseOrder from "./UploadPurchaseModal";
import UploadModal from "../Common/UploadModal";
import UploadDataViewModal from "../Common/UploadDataViewModal";

const PurchaseList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Purchase List");

  let purchaseData = useSelector((state) => state?.customer?.purchase); // User Details from Store
  let purchaseDataTable = useSelector(
    (state) => state?.customer?.purchase?.pagination
  ); // User Details from Store
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [data, setData] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);

  const [parsedData, setParsedData] = useState([]);
  const [showDataModal, setShowDataModal] = useState(false);


  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };

  const handleUploadComplete = (data) => {
    setParsedData(data);        // Store Excel data
    setShowDataModal(true);     // Show the preview modal
  }

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [filterShow, setFilterShow] = useState(false);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const detailedPageInvoice = (purchaseNo) => {
    dispatch(purchaseNr(purchaseNo));
    navigate(Constants.CUSTOMER_V2_PURCHASE_DETAILS);
  };

  const createPO = () => {
    navigate(CustomerConstants.CUSTOMER_V2_PURCHASE_CREATION);
  };

  // Invoice Table Col
  const purchaseDataColumn = [
    {
      name: "Purchase Number",
      id: "documentNumber",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageInvoice(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Transaction",
      selector: (row) => row.transaction,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">{row.transaction}</span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Company",
      selector: (row) => row.companyCode,
      cell: (row) => (
        <>
          <span className="fw-bold text-success">{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Purchase Date",
      id: "createdAt",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <>
          <span className="fw-bold text-primary">
            {formatDateTime(row.createdAt)}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Customer",
      selector: (row) => row.customerCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row.customerName} </p>
          <p className="m-0 p-0 pt-1">{row.customerCode} </p>
        </div>
      ),
    },
    {
      name: "Purchase Value",
      selector: (row) => row?.totals?.poTotalNetValue,
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row?.poTotals?.poTotalNetValue).toFixed(2))}
        </span>
      ),
      sortable: true,
      width: "160px",
    },
  ];

  // Invoice Item Table Col
  const lineItemColInfo = [
    {
      name: "Product",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
          <p className="m-0 p-0 ">{row?.materialCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Load confirm Qty",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.poOrderQuantity} </p>
          <p className="m-0 p-0 ">{row?.uOM} </p>
        </div>
      ),
      width: "150px",
    },
    // {
    //   name: "Unit Price",
    //   cell: (row) => <span>{row?.unitPrice} </span>,
    //   width: "100px",
    // },
    // {
    //   name: "Basic Price",
    //   selector: (row) => row?.basicPrice || "--",
    //   cell: (row) => <span>{row?.basicPrice} </span>,

    //   sortable: true,
    //   width: "120px",
    // },
    {
      name: "Gross Value",
      selector: (row) => row.grossValue || "--",
      cell: (row) => <span>{row.grossValue} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "Basic Amt",
      selector: (row) => row.poBasicAmount || "--",
      cell: (row) => <span>{row.poBasicAmount} </span>,

      sortable: true,
      width: "120px",
    },
    {
      name: "CGST",
      selector: (row) => row?.cgstValue || "--",
      cell: (row) => <span>{row?.cgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row?.sgstValue || "--",
      cell: (row) => <span>{row?.sgstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "GST",
      selector: (row) => row?.gstValue || "--",
      cell: (row) => <span>{row?.gstValue} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "IGST",
      selector: (row) => row?.igstAmount || "--",
      cell: (row) => <span>{row?.igstAmount} </span>,

      sortable: true,
      width: "100px",
    },
    {
      name: "CGST%",
      selector: (row) => row?.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row?.sgst || "--",
      sortable: true,
      width: "100px",
    },
  ];

  const InvoiceColumns = [
    {
      name: "Invoice No",
      selector: (row) => row.invoiceNr,
      sortable: true,
      width: "140px",
    },
    {
      name: "Generated Date",
      selector: (row) => row.generatedDate,
      sortable: true,
      width: "150px",
    },
    {
      name: "Material Desc",
      selector: (row) => row.materialDescription,
      sortable: true,
      // wrap: true,
      width: "200px",
    },
    {
      name: "Material Code",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "150px",
    },
    {
      name: "PO Quantity",
      selector: (row) => row.poOrderQuantity,
      sortable: true,
      // right: true,
      width: "130px",
    },
    {
      name: "UOM",
      selector: (row) => row.uOM,
      sortable: true,
      width: "100px",
    },
    {
      name: "TCS Value",
      selector: (row) => row.tcsValue,
      sortable: true,
      // right: true,
      width: "130px",
    },
    {
      name: "Truck No",
      selector: (row) => row.loadingTruckNo,
      sortable: true,
      width: "130px",
    },
    {
      name: "CGST",
      selector: (row) => row.poTotalCgst,
      sortable: true,
      // right: true,
      width: "100px",
    },
    {
      name: "SGST",
      selector: (row) => row.poTotalSgst,
      sortable: true,
      // right: true,
      width: "100px",
    },
    {
      name: "IGST",
      selector: (row) => row.poTotalIgst,
      sortable: true,
      // right: true,
      width: "100px",
    },
    {
      name: "Net Value",
      selector: (row) => row.poTotalAmount,
      sortable: true,
      // right: true,
      width: "130px",
    },
    {
      name: "Tax Amt",
      selector: (row) => row.gstValue,
      sortable: true,
      // right: true,
      width: "120px",
    },
    {
      name: "Gross Value",
      selector: (row) => row.poTotalNetValue,
      sortable: true,
      // right: true,
      width: "140px",
    },
  ];

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      page: page,
      per_page: getNewPerPage,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPurchaseList(obj));
    setData(purchaseData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getPurchaseList(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      page: page,
      per_page: newPerPage,
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getPurchaseList(obj));
    setData(purchaseData?.data);
  };

  const loadInitialPOData = async () => {
    setData(purchaseData?.data);
  };

  useEffect(() => {
    loadInitialPOData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchaseData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getCustomerIPurchaseList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getPurchaseList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getCustomerInvoiceList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    dispatch(getPurchaseList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Purchase</h2>
                <p className="subText">Lists of Purchase and details</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={purchaseDataColumn}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible1
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>

                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PL</span>
                    </Col>

                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Purchase List</span>
                      <span className="subHeaderTitle">
                        View of Purchase and Status{" "}
                      </span>
                    </Col>
                    {/* <Col xs={4} md={2} lg={2} className="me-2">
                      <button
                        className="btnTable"
                        onClick={createPO}
                      >
                        <i class="bi bi-person-plus"></i> Create PO
                      </button>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="me-2">
                      <button
                        className="btnTable"
                        onClick={() => setShowUploadModal(true)}
                      >
                        Upload
                      </button>
                    </Col> */}
                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={6} md={6} lg={7} className="me-2">
                        <button
                          className="btnTable"
                          onClick={() => setShowUploadModal(true)}
                        >
                          Upload
                        </button>
                      </Col>
                      <Col xs={6} md={6} lg={7} className="me-2">
                        <button
                          className="btnTable"
                          onClick={createPO}
                        >
                          <i class="bi bi-person-plus"></i> Create Po
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={purchaseDataColumn}
                          data={data}
                          progressPending={purchaseData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={purchaseDataTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <UploadModal
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
        onUploadComplete={handleUploadComplete}
      />
      <UploadDataViewModal
        show={showDataModal}
        onHide={() => setShowDataModal(false)}
        data={parsedData}
        columns={InvoiceColumns}
        title="Uploaded Purchase Data"
        onSave={(data) => {
          // Your API save logic here
          console.log("Save", data);
          setShowDataModal(false);
        }}
      />

      {/* <UploadPurchaseOrder
        show={showUploadModal}
        onHide={() => setShowUploadModal(false)}
      // onSuccessUpload={handleUploadSuccess}
      /> */}
    </main>
  );
};

export default PurchaseList;
